import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  selectAll: {
    cursor: "pointer",
    padding: '6px 16px',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: alpha(theme.palette.action.active, theme.palette.action.activatedOpacity),
  },

  field: {
    '& .MuiInputBase-root': {
      //paddingRight: '42px!important',
    }
  },

  actions: {
    position: 'absolute',
    right: 0,
    padding: '0 2px!important',
    '& > *': {
      margin: '0 2px',
    },
  },
  arrow: {
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  arrow_opened: {
    transform: 'rotate(180deg)',
  },

  borderedFlag: {
    width: 20,
    marginRight: 8,
    fontSize: 0,
    '& img': {
      width: 20,
      height: 'auto',
      border: `1px solid ${alpha(theme.palette.secondary.light, 0.2)}`,
    },
  },
  chipAvatar: {
    margin: '0 -4px 0 8px!important',
  },
  chipFlag: {
    display: 'flex',
    width: 18,
    height: 18,
    fontSize: 0,
    '& img': {
      width: 18,
      height: 'auto',
    },
  },

  customScroll: {
    margin: '0 -92px 0px 0px',
    width: 'auto!important',
    '& .view': {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '0 60px 0 0',
    },
    '& .track-vertical': {
      top: 0,
      bottom: 0,
      right: 2,
      borderRadius: '3px',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        width: '100%',
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
    '&.more-icons-3': {
      margin: '0 -131px 0px 0px',
      '& .view': {
        padding: '0 99px 0 0',
      },
    },
  },
}));
